<template>
	<div class="wrap">
		<div class="page">
			<div class="hello">
				<h1>Billing</h1>
				<!-- <p>See your usage below which calculates your bill</p> -->
			</div>
			<div class="grid">
				<div class="row">
					<div class="col-sm-7">
						<div class="bill-estimate">
							<div class="row table-head">
								<div class="col-xs-5">Application</div>
								<div class="col-xs-3">I/O</div>
								<div class="col-xs-2">Time</div>
								<div class="col-xs-2">Total</div>
							</div>
							<!-- put loop here  -->
							<div class="row billing-entry">
								<div class="col-xs-5">NormcoreTestApp</div>
								<div class="col-xs-3">10mb</div>
								<div class="col-xs-2">3hrs</div>
								<div class="col-xs-2">$0</div>
							</div>
							<div class="row billing-entry">
								<div class="col-xs-5">Beat Saber 2</div>
								<div class="col-xs-3">15mb</div>
								<div class="col-xs-2">10hrs</div>
								<div class="col-xs-2">$23</div>
							</div>
							<div class="total">
								<div>$23.00</div>
								<div class="sub">Estimated usage since May 1</div>
							</div>
						</div>
						<div class="fine-print">
							* Usage estimates are calculated hourly and are meant to only provide you a rough idea of your upcoming bill, and help you monitor for unwanted usage spikes. Totals may be subject to change between now and invoicing.		
						</div>
					</div>
					<div class="col-sm-5">
						<div class="payment-description">
							<h3>$23 will be charged to your card *7463 on June 1st.</h3>
							<button>Change Payment Method</button>
						</div>
					</div>
				</div>
			</div>
		</div>
		<Footer />
	</div>
</template>


<script>
// @ is an alias to /src
import Footer from "@/components/Footer.vue";

export default {
  name: "Billing",
  components: {
    Footer
  },
  methods: {

  },
  created() {
  	  //update app.vue with a fake user for now
      this.$emit('updateUser', {id:1});
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  // color: #42b983;
}
.hello {
  width: 70%;
  text-align: left;
  // margin: auto;
  line-height: 1.3;
}
.bill-estimate {
	padding: 20px;
	min-height: 55vh;
	border: 1px solid #CCC;
	// margin: 0 10px;
	border-radius: 20px;
	overflow: hidden;
	text-align: right;
	display: flex;
	flex-direction: column;
	.row {
		:first-child {
			text-align: left;
			overflow: hidden;
		}
		:last-child {
			text-align: right;
		}		
	}
	.total {
		// background-color: black;
		overflow: hidden;
		padding: 15px;
		// font-family: Poppins;
		// color: white;
		// border-bottom: 1px solid #CCC;
		font-size: 2.6em;
		.sub {
			font-size: 14px;
		}
		margin-top: auto;
	}

	.table-head {
		font-size: 12px;
		text-transform: uppercase;
		font-weight: bold;
		text-align: left;
		padding: 20px 15px;
		border-bottom:1px solid #CCC;
		opacity: 0.8;
		letter-spacing: 1px;
		margin-bottom: 10px;


	}
	.billing-entry {
		text-align: left;
		padding: 15px 15px;
		:first-child {
			font-weight: bold;
		}
	}
}

.fine-print {
	font-size: 11px;
	color: #AAA;
	padding: 10px 5px;
	line-height: 1.3;
}

.payment-description {
	h3 {
		margin-top: 0;
		font-size: 1.8em;
		line-height: 1.4;
		margin-bottom: 20px;
		// font-family: Poppins;
		// opacity: 0.9;
	}
	padding: 0 25px;
	
}





</style>